export function accessibleScrollBehavior(): ScrollBehavior {
  if (typeof window.matchMedia !== 'function') {
    return 'auto';
  }

  return window.matchMedia('(prefers-reduced-motion: reduce)').matches
    ? 'auto'
    : 'smooth';
}

export function scrollToTop() {
  window.scrollTo({ top: 0, behavior: accessibleScrollBehavior() });
}
